module.exports = __webpack_public_path__ + "img/img6.773f3726.png";